import moment from 'moment';
import { DateRangePicker } from 'tiny-date-picker/dist/date-range-picker';
import arrayFrom from 'array-from';
import { findParent, dispatchCustomEvent } from '../../tools/helpers';

/**
 * This function gives back the langVariables-Object used in the Datepicker.
 * It sets the Labels for the different parts of the Date- and RangePicker.
 * @param {*} lang - the lang-code (i.e. 'de' or 'en' at this point).
 */
const langOpts = (lang) => {
  let langVariables = null;
  switch (lang) {
    case 'de':
    default:
      langVariables = {
        days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        today: 'Heute',
        clear: 'Löschen',
        close: 'Schließen',
      };
      break;
    case 'en':
      langVariables = {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'Dezember'],
        today: 'Today',
        clear: 'Clear',
        close: 'Close',
      };
  }

  return langVariables;
};


class NetworkIndicatorDownloadBox {
  constructor(options = {}) {
    this.element = options.element;
    this.type = this.element.dataset.type;
    this.display = this.element.dataset.display;
    this.viewOptions = {
      baseClass: arrayFrom(this.element.classList).filter(value => value.includes('org--'))[0],
    };

    this.config = {
      latest: new Date(),
      first: new Date(),
    };

    this.contentRow = findParent(this.element, 'org--content-row');
    this.index = arrayFrom(this.contentRow.classList).filter(value => value.includes('row-index'))[0].split('-')[2];

    this.lang = document.querySelector('html').lang || 'de';
    this.date = moment(this.config.latest, 'DD.MM.YYYY');
    this.data = {};
    this.startDate = moment(this.config.latest, 'DD.MM.YYYY');
    this.endDate = moment(this.config.latest, 'DD.MM.YYYY');

    this.init();
  }

  init() {
    this.initDates();

    window.addEventListener(`row-${this.index}-range-changed`, () => {
      this.initDownloads();
    });
  }

  initDates() {
    if (this.viewOptions.isHistory !== 'true') {
      // fetch('https://internet-stage.ampintern.net/api/grid-data/config/EEG_RESTABWEICHUNG/quarterhour')
      fetch(`/api/grid-data/config/${this.type}/${this.display}`)
        .then(res => res.json())
        .then((result) => {
          this.config = result;
          this.initDatePickers();
          this.initDownloads();
        })
        .catch((error) => {
          console.error('Config Fetch Failed: ', error);
          this.config = {
            latest: new Date(),
            first: new Date(),
          };
          this.initDatePickers();
          this.initDownloads();
        });
    } else {
      this.config = {
        latest: new Date(),
        first: new Date(),
      };
      this.initDatePickers();
      this.initDownloads();
    }
  }

  /**
   * Init the Datepickers and if Show-Datepicker is false hide the filters.
   */
  initDatePickers() {
    // max and min values set the allowed range within the date range picker and need to have correct values before initialization
    this.datepickerRange = new DateRangePicker(this.element.querySelector(`.${this.viewOptions.baseClass}__calendar-start`), {
      appendTo: this.element.querySelector(`.${this.viewOptions.baseClass}__calendar-start`),
      mode: 'dp-permanent',
      startOpts: {
        dayOffset: 1,
        max: moment(this.config.latest, 'DD.MM.YYYY').format('MM/DD/YYYY'),
        min: moment(this.config.first, 'DD.MM.YYYY').format('MM/DD/YYYY'),
        lang: langOpts(this.lang),
      },
      endOpts: {
        dayOffset: 1,
        max: moment(this.config.latest, 'DD.MM.YYYY').format('MM/DD/YYYY'),
        min: moment(this.config.first, 'DD.MM.YYYY').format('MM/DD/YYYY'),
        lang: langOpts(this.lang),
      },
    });

    this.datepickerRange.setState({
      view: 'month',
      start: new Date(moment(this.config.latest, 'DD.MM.YYYY').startOf('month').format('MM/DD/YYYY')),
      end: new Date(moment(this.config.latest, 'DD.MM.YYYY').format('MM/DD/YYYY')),
    });

    this.datepickerRange.on({
      statechange: (_, dp) => {
        this.startDate = dp.state.start;
        this.endDate = dp.state.end;
        dispatchCustomEvent(`row-${this.index}-range-changed`, {
          startDate: this.startDate,
          endDate: this.endDate,
        });
      },
    });
  }

  /**
   * Init the Download Buttons
   */
  initDownloads() {
    const downloadButtons = this.element.querySelector(`.${this.viewOptions.baseClass}__downloads`).querySelectorAll('[data-file-type]');
    arrayFrom(downloadButtons).forEach((button) => {
      const b = button;
      b.href = `/api/grid-data/items/${button.dataset.fileType}/${this.type}/${moment(this.startDate).format('YYYY-MM-DD')}/${moment(this.endDate).format('YYYY-MM-DD')}`;
      b.type = button.dataset.fileType;
    });
  }

}

export default NetworkIndicatorDownloadBox;
